import { Component, inject, OnInit, OnDestroy, HostListener } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { GlobalService } from "../../serivces/global.service";
import { ToastrService } from "ngx-toastr";
import { SharedModule } from "../../shared/shared.module";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { OtpInputComponent } from "@frontend/app/components/otp-input/otp-input.component";

@Component({
  selector: "app-log-in",
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule, OtpInputComponent],
  templateUrl: "./log-in.component.html",
  styleUrls: ["./log-in.component.scss"],
})
export class LogInComponent implements OnInit, OnDestroy {
  // Component dependencies
  private GlobalService = inject(GlobalService);
  private router = inject(Router);
  private readonly toastrService = inject(ToastrService);

  // Form state
  UserMobileNo = "";
  OTP = "";
  showSendOtpButton = false;
  showOtpField = false;
  isOtpSent = false;
  otpArray: string[] = new Array(6).fill("");
  readonly SVG_ICONS = SVG_ICONS;

  ngOnInit() {
    this.GlobalService.setIsShowFalse();
    this.GlobalService.setIsLoggedInFalse();
    this.disableScroll();
  }

  ngOnDestroy() {
    this.enableScroll();
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    // Prevent scrolling by always scrolling to top
    window.scrollTo(0, 0);
  }

  private disableScroll() {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";
  }

  private enableScroll() {
    document.body.style.overflow = "";
    document.body.style.height = "";
  }

  //#region variables
  // UserMobileNo = "";
  // OTP = "";
  // showSendOtpButton = false;
  // showOtpField = false;
  // isOtpSent = false;
  otp: string[] = new Array(6).fill("");
  // readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  onMobileChange() {
    this.showSendOtpButton = this.UserMobileNo.length === 10;
    if (!this.showSendOtpButton) {
      this.showOtpField = false;
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  editNumber() {
    this.isOtpSent = false;
    this.showOtpField = false;
    this.OTP = "";
    this.otpArray = new Array(6).fill("");
  }

  sendOtp() {
    this.GlobalService.generateOTP(this.UserMobileNo).subscribe({
      next: res => {
        // this.OTP = res.otp;
        this.isOtpSent = true;
        this.showOtpField = true;
        this.toastrService.success(`OTP Sent to ${this.UserMobileNo}`);
        // this.toastrService.success(`OTP is ${res.otp}`);
      },
    });
  }

  onOtpComplete(otp: string) {
    this.OTP = otp;
    this.onLogin();
  }

  onLogin() {
    // Check if OTP is complete (all 6 digits)
    if (!this.OTP || this.OTP.length !== 6) {
      this.toastrService.error("Please enter a valid 6-digit OTP");
      return;
    }

    this.GlobalService.onLogin(this.UserMobileNo, this.OTP).subscribe({
      next: res => {
        if (!res || !res.Table) {
          this.toastrService.error("Invalid response from server");
          return;
        }

        console.log(res);

        sessionStorage.setItem("Token", res.Table1 || "");
        sessionStorage.setItem("UserID", res.Table.UMID || "");
        sessionStorage.setItem("TrainerID", res.Table.TrainerID || "");
        sessionStorage.setItem("AllCenterIDs", JSON.stringify(res.Table.AllCenterIDs || []));
        sessionStorage.setItem("AllRegionIDs", JSON.stringify(res.Table.AllRegionIDs || []));
        sessionStorage.setItem("AllAreaIDs", JSON.stringify(res.Table.AllAreaIDs || []));
        sessionStorage.setItem("UserLoginID", res.Table.UserLoginID || "");
        // sessionStorage.setItem("Latitude", "21.187849584368514");
        // sessionStorage.setItem("Longitude", "72.73859899844268");

        if (res.Table.UserTypes && res.Table.UserTypes.length > 0) {
          const userTypeIDs = res.Table.UserTypes.map((ut: any) => ut.UserTypeID).join(",");
          sessionStorage.setItem("UserTypeID", userTypeIDs);
        }

        if (res.Table2) {
          sessionStorage.setItem("permissions", JSON.stringify(res.Table2));
        }

        // this.GlobalService.permission.set(permissions);

        this.toastrService.success("Login successful!");
        this.router.navigate(["center-select-page"]);
      },
    });
  }

  onInquiryForm() {
    this.router.navigate(["inquiry-form"]);
  }
}
